var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-map-popup',{attrs:{"titleVisible":false}},[_c('div',{class:_vm.$style.main},[_c('div',{staticClass:"minimap-popup-header",class:_vm.$style.header},[_c('i',{staticClass:"el-icon-close",class:_vm.$style.close,on:{"click":_vm.onCloseClick}})]),_vm._v(" "),_c('div',{class:_vm.$style.view,attrs:{"id":"overview"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0587786","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/topologymap/components/monitoring/MinimapWindow.vue
// module id = null
// module chunks = 